export const getDaysBetweenDates = (dateInitial:number, dateFinal:number) => (dateFinal - dateInitial) / (1000 * 3600 * 24)
